import type { GetPendingChatRequests200ItemCurrentUserStatus } from './getPendingChatRequests200ItemCurrentUserStatus';
import type { GetPendingChatRequests200ItemParticipantsItem } from './getPendingChatRequests200ItemParticipantsItem';

export type GetPendingChatRequests200Item = {
  chatRoomId: number;
  createdAt: string;
  currentUserStatus?: GetPendingChatRequests200ItemCurrentUserStatus;
  isGroupThread: boolean;
  /** @nullable */
  lastMessage?: string | null;
  /** @nullable */
  lastMessageTime?: string | null;
  participants: GetPendingChatRequests200ItemParticipantsItem[];
  /** @nullable */
  unreadMessageCount?: number | null;
};
